/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RoofStructureIssueEnum = 1 | 2 | 3 | 4 | 5 | 6;

export const RoofStructureIssueEnum = {
    NUMBER_1: 1 as RoofStructureIssueEnum,
    NUMBER_2: 2 as RoofStructureIssueEnum,
    NUMBER_3: 3 as RoofStructureIssueEnum,
    NUMBER_4: 4 as RoofStructureIssueEnum,
    NUMBER_5: 5 as RoofStructureIssueEnum,
    NUMBER_6: 6 as RoofStructureIssueEnum
};

